export class NumberUtil {
    static isNumeric(value: any): boolean {
        return !isNaN(value - parseFloat(value));
    }
}
